export const css = {
    root: 'KJIHoZ_q',
    'button-1380': '_3CuU9_H6',
    ' _key': 'ascm-theme/ascm/variants/ascmpreview'
};
export default css;
